module.exports = __webpack_public_path__ + "img/Mestari-Heittäjä-II.913e32de.png";